import api from "./index";

export async function getRating(params) {
  return api.get(`/rating`, { params: params });
}
